export const AmenitiesTableconstant = {
  AMENITIES_TABLE_SAGA: "AMENITIES_TABLE_SAGA",
  AMENITIES_TABLE_REQUEST: "AMENITIES_TABLE_REQUEST",
  AMENITIES_TABLE_RESPONSE: "AMENITIES_TABLE_RESPONSE",
  AMENITIES_TABLE_API: "amenities",

  // POST_AMENITIES:"",

  POST_AMENITIES_SAGA: "POST_AMENITIES_SAGA",
  POST_AMENITIES_REQUEST: "POST_AMENITIES_REQUEST",
  POST_AMENITIES_RESPONSE: "POST_AMENITIES_RESPONSE",
  POST_AMENITIES_API: "/amenity",

  ENABLE_DESABLE_AMENITIES_SAGA: "ENABLE_DESABLE_AMENITIES_SAGA",
  ENABLE_DESABLE_AMENITIES_REQUEST: "ENABLE_DESABLE_AMENITIES_REQUEST",
  ENABLE_DESABLE_AMENITIES_RESPONSE: "ENABLE_DESABLE_AMENITIES_RESPONSE",
  ENABLE_DESABLE_AMENITIES_API: "/amenity",

  UPDATE_AMENITIES_SAGA: "UPDATE_AMENITIES_SAGA",
  UPDATE_AMENITIES_REQUEST: "UPDATE_AMENITIES_REQUEST",
  UPDATE_AMENITIES_RESPONSE: "UPDATE_AMENITIES_RESPONSE",
  UPDATE_AMENITIES_API: "/amenity",
};
